import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Icon } from '@lomarengas/design-system';
import { DataTable, SectionHeader } from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { getAccommodationTags, selectTagDataTableItems } from './tagsSlice';

const AddNewButton = (
  <Link to="/accommodations/tags/new" className="btn btn-blue ps-16">
    <Icon CssClass="me-8" AriaLabel="Uusi" Name="plus" />
    Lisää uusi hintaryhmä tagi
  </Link>
);

function Tags() {
  const dispatch = useAppDispatch();
  const tagDataTableItems = useAppSelector(selectTagDataTableItems);

  useEffect(() => {
    dispatch(getAccommodationTags());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>Hintaryhmä tagit</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Title="Hintaryhmä tagit"
          Breadcrumbs={['Majoitukset ja Ryhmät']}
          Children={AddNewButton}
        />

        <DataTable
          ColumnWidths={[null, null]}
          Header={['Nimi', 'Toiminnot']}
          Items={tagDataTableItems}
          LegendText={tagDataTableItems.length > 1 ? 'tagia' : 'tagi'}
          TotalItems={tagDataTableItems.length}
        />
      </Container>
    </>
  );
}

export default Tags;
